import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { DfUiModule } from '@df/ui/df-ui.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ButtonStyleComponent } from 'projects/app-default/src/app/common/buttons/button-style/button-style.component';
import { InlineButtonComponent } from 'projects/app-default/src/app/common/buttons/inline-button/inline-button.component';
import { NTextBox, TextBoxComponent } from 'projects/app-default/src/app/common/text-box/text-box.component';

export namespace NCmsImageGrid {
    export const componentId = 'image-grid';

    export interface IComponentData extends NICmsContentComponent.IData, NTextBox.IData {
        sectionName: string;
        items: IItem[];
    }

    export interface IItem {
        image: string;
        title: string;
        subtitle?: string;
        cta?: string;
        url?: string;
        anchorId?: string;
    }
}

@ICmsComponent<CmsImageGridComponent>({
    id: NCmsImageGrid.componentId,
    name: 'Image Grid',
    onDemandOnly: true,
    fields: [
        ...NTextBox.getFields(false, true),
        {
            key: 'sectionName',
            type: NICmsContentField.EFieldType.text,
            title: 'Section Name',
            default: 'Section Name',
            required: true
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'items',
            title: 'Item',
            itemName: 'Item',
            itemNameField: 'item',
            defaultSize: 1,
            required: true,
            fields: [
                {
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image',
                    required: true
                },
                {
                    key: 'title',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Title',
                    required: true
                },
                {
                    key: 'subtitle',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Subtitle'
                },
                {
                    key: 'cta',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Button label',
                    default: 'Read more'
                },
                {
                    key: 'url',
                    type: NICmsContentField.EFieldType.text,
                    title: 'URL'
                },
                {
                    key: 'anchorId',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Anchor ID'
                }
            ]
        }
    ]
})
@Component({
    standalone: true,
    imports: [
        TextBoxComponent,
        DfModuleImageModule,
        ICmsClientModule,
        DfUiModule,
        GridModule,
        ButtonStyleComponent,
        InlineButtonComponent,
        HrefComponent
    ],
    selector: 'cms-image-grid',
    templateUrl: './cms-image-grid.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsImageGridComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsImageGrid.IComponentData;
}
